import SearchWidget from './widgets/SearchWidget';
import SuggestionsWidget from './widgets/SuggestionsWidget';
import TrendingWidget from './widgets/TrendingWidget';
import AdminStatsWidget from './widgets/AdminStatsWidget';

/**
 * Registry of right-sidebar widgets.
 *
 * Each entry is a self-contained unit:
 *  - id:            stable identifier persisted in user preferences
 *  - component:     React component rendering the widget body
 *  - titleKey:      i18n key for the default title shown in the WidgetShell
 *  - defaultOrder:  order used on first render / after reset
 *  - defaultEnabled optional; defaults to true
 *  - adminOnly:     when true, only rendered for admin users (component self-guards too)
 *
 * To add a new widget, implement it under ./widgets and register it here.
 * The sidebar, the manager and the persistence layer pick it up automatically.
 */
const widgetRegistry = {
  adminStats: {
    id: 'adminStats',
    component: AdminStatsWidget,
    titleKey: 'rightSidebar.widgets.adminStats.title',
    defaultOrder: 0,
    defaultEnabled: true,
    adminOnly: true,
    pinToTop: true,
  },
  search: {
    id: 'search',
    component: SearchWidget,
    titleKey: 'rightSidebar.widgets.search.title',
    defaultOrder: 1,
    defaultEnabled: true,
  },
  suggestions: {
    id: 'suggestions',
    component: SuggestionsWidget,
    titleKey: 'rightSidebar.widgets.suggestions.title',
    defaultOrder: 2,
    defaultEnabled: true,
  },
  trending: {
    id: 'trending',
    component: TrendingWidget,
    titleKey: 'rightSidebar.widgets.trending.title',
    defaultOrder: 3,
    defaultEnabled: true,
  },
};

export const listRegisteredWidgets = () =>
  Object.values(widgetRegistry).sort((a, b) => a.defaultOrder - b.defaultOrder);

export const getDefaultPreferences = () =>
  listRegisteredWidgets().map((widget) => ({
    id: widget.id,
    enabled: widget.defaultEnabled !== false,
    pinToTop: widget.pinToTop || false,
  }));

export default widgetRegistry;
